import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { AccountUserDataDispatcher } from './account-user-data.dispatcher';
import { AccountUserDataEffects } from './account-user-data.effects';
import { FEATURE_NAME, reducer } from './account-user-data.reducer';
import { AccountUserDataService } from './account-user-data.service';
import { AccountUserDataStore } from './account-user-data.store';

export const accountUserDataEffects = [AccountUserDataEffects];

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(FEATURE_NAME, reducer)],
})
export class AccountUserDataModule {
  static forRoot(): ModuleWithProviders<AccountUserDataModule> {
    return {
      ngModule: AccountUserDataModule,
      providers: [
        AccountUserDataStore,
        AccountUserDataDispatcher,
        AccountUserDataService,
      ],
    };
  }
}
